import { supabase } from './supabase';

async function requireSession() {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) throw error;
  if (!session) throw new Error('No active Supabase session');
  return session;
}

export async function fetchCurrentRole(userId) {
  await requireSession();
  const { data, error } = await supabase
    .from('profiles')
    .select('role')
    .eq('id', userId)
    .single();
  if (error) {
    console.error('[Supabase] fetchCurrentRole →', error.code, error.message);
    return null;
  }
  return data?.role ?? null;
}

export async function adminListUsers() {
  await requireSession();
  const { data, error } = await supabase
    .from('profiles')
    .select('id, email, role, created_at, portfolios(count)')
    .order('created_at');
  if (error) {
    console.error('[Supabase] adminListUsers →', error.code, error.message);
    throw error;
  }
  return data ?? [];
}

export async function adminGetUserPositions(userId) {
  await requireSession();
  const { data, error } = await supabase
    .from('portfolios')
    .select('id, name, positions(id, symbol, quantity, buy_price, buy_date)')
    .eq('user_id', userId);
  if (error) {
    console.error('[Supabase] adminGetUserPositions →', error.code, error.message);
    throw error;
  }
  return data ?? [];
}

// Through admin_set_user_role() (migrations/sprint11.sql): once that file
// runs, authenticated can no longer write `role` directly, and the function
// checks on the server that the caller is an admin. Until it runs the
// function does not exist, and the old direct update is used.
export async function adminSetUserRole(userId, role) {
  await requireSession();
  const rpc = await supabase.rpc('admin_set_user_role', { target: userId, new_role: role });
  if (!rpc.error) return;
  const missing = /PGRST202|42883|could not find the function/i.test(`${rpc.error.code || ''} ${rpc.error.message || ''}`);
  if (!missing) {
    console.error('[Supabase] adminSetUserRole (rpc) →', rpc.error.code, rpc.error.message);
    throw rpc.error;
  }
  const { error } = await supabase
    .from('profiles')
    .update({ role })
    .eq('id', userId);
  if (error) {
    console.error('[Supabase] adminSetUserRole →', error.code, error.message);
    throw error;
  }
}
